import PaidHolidayAlert from './PaidHolidayAlert';

export default PaidHolidayAlert;
